import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBCol,
  MDBRow,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import MainLinks from "../../navlinks/MainLinks";
import Body from "../../body/BodyPage";
// import LocSchedule from "../location/LocSchedule";
import { useForm } from "react-hook-form";
import OpenSchedule from "./OpenSchedule";
import { useLocation } from "react-router";
import {
  getMisc,
  getSpecificLunaDetails,
  // updateLunaDetails,
  updateLunaSettings,
} from "../../../apiclients/streamsapi_bridge";
import LunaGeneralSettings from "./LunaGeneralSettings";
import TopSuccess from "../../header/TopSuccess";
import TopMessage from "../../header/TopMessage";
import SaveChanges from "../../topviews/saveCancel";
import LunaLocation from "./LunaLocation";
import LunaLocSchedule from "../location/LunaLocSchedule";
import ImportProgressWarning from "../../../apiclients/ImportProgressWarning";
import { getImpExpStatusNew } from "../../../apiclients/CommonUtils";
import ImpExpRedirectPopup from "../../../apiclients/ImpExpRedirectPopup";
import ImportUser from "../user/ImportUser";
function LunaSettings() {
  const containerRef = useRef(null);
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [basicActive, setBasicActive] = useState("tab1");
  const [selectedPHnums, setSelectedPHnums] = useState(["+1 408 237 6909"]);
  const location = useLocation();
  const [lunaInfo, setLunaInfo] = useState(
    location.state ? location.state : {}
  );
  const [message, setMessage] = useState([]);
  const [hgcode, sethgcode] = useState("");
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [sourceNumber, setSourceNumber] = useState([]);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [holidaysList, setHolidaysList] = useState([]);
  const [locationid, setLocationId] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [rerender, setRerender] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [phoneNumbers, setphoneNumbers] = useState([]);
  const [twentyFourSeven, settwentyFourSeven] = useState(false);
  const [lunaName, setlunaName] = useState("");
  const [lunaExtension, setlunaExtension] = useState("");
  const [allLocations, setAllLocations] = useState([]);
  const [billingGroupList, setBillingGroupList] = useState([]);
  const [enableHolidays, setenableHolidays] = useState(false);
  const [locations, setlocations] = useState([]);
  const [customSchedule, setCustomSchedule] = useState({});

  const [assocCallFlows, setAssocCallFlows] = useState([]);
  const [showExportWarning, setShowExportWarning] = useState(false);
  const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    setError,
    setFocus,
    reset,
    getValues,
    watch,
    clearErrors,
    control,
    unregister,
  } = useForm({
    defaultValues: {
      general: {
        name: "",
        extension: "",
        loc_id: "",
        bill_grp_id: "",
        voice_type: 1,
      },
      loc: {
        is_perm_enabled: false,
        edit_perm: [],
      },

      schedule: {
        all_time: false,
        sch_loc_id: "",
        weekly_schedule: {
          sun: {
            selected: false,
            from_time: "",
            to_time: "",
            twenty_four: false,
          },
          mon: {
            selected: true,
            from_time: "",
            to_time: "",
            twenty_four: false,
          },
          tue: {
            selected: false,
            from_time: "",
            to_time: "",
            twenty_four: false,
          },
          wed: {
            selected: false,
            from_time: "",
            to_time: "",
            twenty_four: false,
          },
          thu: {
            selected: false,
            from_time: "",
            to_time: "",
            twenty_four: false,
          },
          fri: {
            selected: false,
            from_time: "",
            to_time: "",
            twenty_four: false,
          },
          sat: {
            selected: false,
            from_time: "",
            to_time: "",
            twenty_four: false,
          },
        },
      },
      // holidays: {
      //     holiday_id: "",
      //     name: "",
      //     from: "",
      //     to: "",
      // },
    },
  });
  const { isDirty, errors, dirtyFields } = formState;

  const [schedules, setSchedules] = useState([]);

  console.log("isDirty:::::::", isDirty);
  console.log("dirtyFields:::::::", JSON.stringify(dirtyFields));
  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["all_locations", "billinggroups"],
      }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      // navigate("/");
    }

    // console.log("reponse to fech billing loc misc :::: " + JSON.stringify(tdata));

    const lunaInfo_resp = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["location_luna_schedules"],
        luna_id: lunaInfo.lunaid,
      }
    );
    const luna_info = await lunaInfo_resp.json();
    const lunaDetails = luna_info?.misc ?? {};
    console.log("Schedule data is ::::::::::; " + JSON.stringify(lunaDetails.all_schedules));
    const hasCustomSchedule = lunaDetails?.all_schedules?.some(item => item.schedule_type === 1);
    
    const formattedSchedules = lunaDetails?.all_schedules?.map((item) => ({
      text: item.name + (item.schedule_type === 1 ? " (Custom)" : ""),
      value: parseInt(item.unique_key),
      schedule_type: item.schedule_type,
      id: parseInt(item.id),
    })) || [];
    
    setSchedules(
      hasCustomSchedule
        ? formattedSchedules
        : [{ value: -1, text: "Create New" }, ...formattedSchedules]
    );

    setAllLocations(
      tdata.misc.all_locations.map((item) => ({
        text: item.loc_name,
        value: parseInt(item.loc_id, 10), // Ensure id is a number
      }))
    );
    setBillingGroupList(
      (tdata?.misc?.billinggroups ?? []).map((item) => ({
        text: item.groupname,
        value: parseInt(item.groupid, 10), // Ensure id is a number
      }))
    );
  }



  useEffect(() => {
    if ((lunaInfo.lunaid || rerender) && basicActive === "tab1") {
      fetchSpecificLunaDetails();
      fetchData();
      setRerender(false);
    }
  }, [lunaInfo.lunaid, rerender, basicActive]);

  const fetchSpecificLunaDetails = async () => {
    try {
      setIsloading(true);
      const response = await getSpecificLunaDetails(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        lunaInfo.lunaid
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      const lunaDetails = await response.json();
      console.log(
        "getSpecific getSpecificLunaDetails ::: " + JSON.stringify(lunaDetails)
      );
      setphoneNumbers(lunaDetails?.luna_details?.general?.phoneNumbers ?? []);
      const holidayList = lunaDetails?.luna_details?.holidays ?? [];
      setHolidaysList(holidayList);
      setenableHolidays(holidayList && holidayList.length > 0 ? true : false);
      settwentyFourSeven(
        lunaDetails?.luna_details?.schedule?.all_time ?? false
      );

      setlunaName(lunaDetails?.luna_details?.general?.name ?? "");
      setlunaExtension(lunaDetails?.luna_details?.general?.extension ?? "");
      setlocations(lunaDetails?.luna_details?.loc ?? []);
      console.log("associated_callflows :::::", lunaDetails?.luna_details?.associated_callflows)
      setAssocCallFlows(lunaDetails?.luna_details?.associated_callflows)
      const isLocationEnabled = (lunaDetails?.luna_details?.loc ?? []).some(
        (loc) => loc.flag === 1
      );
      setCustomSchedule({ id: lunaDetails?.luna_details?.schedule?.sch_loc_id ?? "", type: lunaDetails?.luna_details?.schedule?.iscustom !== undefined ? lunaDetails.luna_details.schedule.iscustom * 1 : 0 })
      console.log(
        "value is for monday :::::::::: " +
        lunaDetails?.luna_details?.schedule?.weekly_schedule?.mon?.to_time
      );
      reset({
        general: {
          name: lunaDetails?.luna_details?.general?.name ?? "",
          extension: lunaDetails?.luna_details?.general?.extension ?? "",
          loc_id: lunaDetails?.luna_details?.general?.loc_id ?? "",
          bill_grp_id: lunaDetails?.luna_details?.general?.billl_grp_id ?? "",
          voice_type: lunaDetails?.luna_details?.general?.voice_type
            ? parseInt(lunaDetails?.luna_details?.general?.voice_type)
            : 1,
        },
        loc: {
          is_perm_enabled: isLocationEnabled,
          edit_perm: [],
        },
        schedule: {
          schedule_type: lunaDetails?.luna_details?.schedule?.iscustom,
          all_time: lunaDetails?.luna_details?.schedule?.all_time ?? false,
          sch_loc_id: lunaDetails?.luna_details?.schedule?.sch_loc_id ?? "",
          weekly_schedule: {
            sun: {
              selected:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.sun
                  ?.selected ?? false,
              from_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.sun
                  ?.from_time ?? "8:00 AM",
              to_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.sun
                  ?.to_time ?? "5:00 PM",
              twenty_four:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.sun
                  ?.twenty_four ?? false,
            },
            mon: {
              selected:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.mon
                  ?.selected ?? false,
              from_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.mon
                  ?.from_time ?? "8:00 AM",
              to_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.mon
                  ?.to_time ?? "5:00 PM",
              twenty_four:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.mon
                  ?.twenty_four ?? false,
            },
            tue: {
              selected:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.tue
                  ?.selected ?? false,
              from_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.tue
                  ?.from_time ?? "8:00 AM",
              to_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.tue
                  ?.to_time ?? "5:00 PM",
              twenty_four:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.tue
                  ?.twenty_four ?? false,
            },
            wed: {
              selected:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.wed
                  ?.selected ?? false,
              from_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.wed
                  ?.from_time ?? "8:00 AM",
              to_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.wed
                  ?.to_time ?? "5:00 PM",
              twenty_four:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.wed
                  ?.twenty_four ?? false,
            },
            thu: {
              selected:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.thu
                  ?.selected ?? false,
              from_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.thu
                  ?.from_time ?? "8:00 AM",
              to_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.thu
                  ?.to_time ?? "5:00 PM",
              twenty_four:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.thu
                  ?.twenty_four ?? false,
            },
            fri: {
              selected:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.fri
                  ?.selected ?? false,
              from_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.fri
                  ?.from_time ?? "8:00 AM",
              to_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.fri
                  ?.to_time ?? "5:00 PM",
              twenty_four:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.fri
                  ?.twenty_four ?? false,
            },
            sat: {
              selected:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.sat
                  ?.selected ?? false,
              from_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.sat
                  ?.from_time ?? "8:00 AM",
              to_time:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.sat
                  ?.to_time ?? "5:00 PM",
              twenty_four:
                lunaDetails?.luna_details?.schedule?.weekly_schedule?.sat
                  ?.twenty_four ?? false,
            },
          },
        },
      });

      setRerender(false);
    } catch (error) { }
  };

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    }
  }, [successMessage]);

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  const onSubmit = async (data) => {
    let modifiedData = extractModifiedFields(dirtyFields, data);
    if (modifiedData) {
      modifiedData.reqid = 149;
      modifiedData.schedule_id = data.schedule.sch_loc_id;
      modifiedData.schedule_type = data.schedule.schedule_type;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.lunaid = parseInt(lunaInfo.lunaid);

      console.log(
        "modified data for company info :::" + JSON.stringify(modifiedData)
      );
      // return;
      setIsloading(true);
      let saverep = await updateLunaSettings(modifiedData);
      console.log(`reponse of Edit Luna :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(
        "response of modified data Luna  :::" + JSON.stringify(saverepeMsg)
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      }
    }
  };

  const handleImportAndSubmit = async () => {
    if (dirtyFields?.general?.extension) {
      const result = await getImpExpStatusNew();
      if (result.status !== 0) {
        if (result.isOwnUser) {
          setShowImpExpRedirect(true);
        } else {
          const { userInfo } = result;
          if (userInfo?.isaccount) {
            setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
          } else {
            setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
          }
          exportwarningToggle();
        }
        return;
      }
    }
    handleSubmit(onSubmit)();
  };

  function extractModifiedFields(dirtyFields, data) {
    const modifiedData = {};
    function recurse(dirtyFields, data, modifiedData, path = "") {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          const currentPath = path ? `${path}.${field}` : field;
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
            recurse(
              dirtyFields[field],
              data[field],
              modifiedData[field],
              currentPath
            );
            if (field === "loc" && modifiedData[field]?.edit_perm?.length > 0) {
              modifiedData[field].is_perm_enabled = data[field].is_perm_enabled;
            } else if (field === "weekly_schedule") {
              const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
              for (const day of days) {
                if (dirtyFields[field][day]) {
                  // Initialize if not exists
                  if (!modifiedData[field]) modifiedData[field] = {};
                  if (!modifiedData[field][day]) modifiedData[field][day] = {};

                  // If twenty_four is modified, include from_time and to_time as well
                  if (dirtyFields[field][day].twenty_four !== undefined) {
                    modifiedData[field][day].from_time =
                      data[field][day].from_time;
                    modifiedData[field][day].to_time = data[field][day].to_time;
                  }
                }
              }
            }
          } else if (
            Array.isArray(data[field]) &&
            Array.isArray(dirtyFields[field]) &&
            currentPath === "loc.edit_perm"
          ) {
            modifiedData[field] = data[field]
              .map((item, index) => {
                if (
                  dirtyFields[field][index]?.flag ||
                  dirtyFields[field][index]?.info
                ) {
                  return {
                    val: item.id,
                    ...(dirtyFields[field][index]?.flag && {
                      is_active: item.flag,
                    }),
                    ...(dirtyFields[field][index]?.info && {
                      info: item.info,
                    }),
                  };
                }
                return null;
              })
              .filter((item) => item !== null);
          } else {
            modifiedData[field] = data[field];
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

  function closeSave(e) {
    setRerender(true);
    reset();
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Find the specific sticky container
      const stickyParent = document.querySelector(".sticky-top");
      if (!stickyParent) return;

      // Only select .nav-link elements inside that container
      const scrollspyLinks = stickyParent.querySelectorAll(".nav-link");

      // Remove 'active' from all links in the sticky area
      scrollspyLinks.forEach((link) => {
        link.classList.remove("active");
      });

      // Add 'active' only to the first one
      if (scrollspyLinks.length > 0) {
        scrollspyLinks[0].classList.add("active");
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <React.Fragment>
      <MainLinks active={2} />
      <Body
        tablinks={2}
        sublink={42}
        content={
          <>
            <section className="mb-3">
              <div className="card card-height overflow-hidden">
                <div className="card-header py-3 px-0">
                  <h5 className="mb-0 ">
                    <MDBBreadcrumb>
                      <MDBBreadcrumbItem>
                        <a href="/phonenumbers">
                          <strong>{t("phoneSystem")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem active>
                        <a href="/luna-landing">
                          <strong>Luna AI</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem>
                        <strong>{lunaName}</strong>
                      </MDBBreadcrumbItem>
                    </MDBBreadcrumb>
                  </h5>
                </div>
                <div className="card-body px-0">
                  <div className="d-flex">
                    <div class="pb-2 d-flex align-items-center square me-3 pe-3">
                      {/* <div className="user-icon">
                        <i class="fas fa-user fs-4"></i>
                      </div> */}
                      <div>
                        <h5 class="fw-600 m-0">{lunaName}</h5>
                        <p class=" text-secondary">
                          Extension : <b> {lunaExtension}</b>
                        </p>
                      </div>
                    </div>
                    {assocCallFlows && assocCallFlows?.length > 0 && (
                      <div className="border-start ps-3">
                        <h6 >
                          <strong className="mt-3 mb-0">
                            Associated Call Flow
                          </strong>
                          <div className="d-flex">
                            {assocCallFlows?.map((obj, index) => (
                              <p className="chip chip-tag" key={index}>
                                {obj.name} : {obj.extension}
                              </p>
                            ))}
                          </div>

                        </h6>
                      </div>
                    )}
                  </div>

                  <MDBTabs className="mb-3">
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab1")}
                        active={basicActive === "tab1"}
                      >
                        {t("settings")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                    {twentyFourSeven && (
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                        >
                          24/7
                        </MDBTabsLink>
                      </MDBTabsItem>
                    )}
                    {!twentyFourSeven && (
                      <>
                        <MDBTabsItem>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab3")}
                            active={basicActive === "tab3"}
                          >
                            Open
                          </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab4")}
                            active={basicActive === "tab4"}
                          >
                            Closed
                          </MDBTabsLink>
                        </MDBTabsItem>
                      </>
                    )}
                    {enableHolidays && (
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab5")}
                          active={basicActive === "tab5"}
                        >
                          Holidays
                        </MDBTabsLink>
                      </MDBTabsItem>
                    )}
                  </MDBTabs>

                  <MDBTabsContent>
                    <MDBTabsPane open={basicActive === "tab1"}>
                      <MDBRow>
                        <MDBCol
                          size="2"
                          md="2"
                          lg="2"
                          sm="12"
                          className="col-sm-100 pr-0 leftTabs"
                        >
                          <MDBScrollspy container={containerRef} offset={100}>
                            <MDBScrollspyLink targetRef={section1}>
                              {t("general")}
                            </MDBScrollspyLink>
                            <MDBScrollspyLink targetRef={section2}>
                              Locations
                            </MDBScrollspyLink>
                            <MDBScrollspyLink
                              targetRef={section3}
                              id="schedule"
                            >
                              Weekly Schedule
                            </MDBScrollspyLink>
                          </MDBScrollspy>
                        </MDBCol>

                        <MDBCol
                          size="12"
                          md="10"
                          sm="12"
                          pr-0
                          className="col-sm-100 pr-0 leftTabContent lunaleftTabContent"
                        >
                          <div ref={containerRef} className="scrollspy-example">
                            <section ref={section1} id="section-1">
                              <LunaGeneralSettings
                                register={register}
                                setValue={setValue}
                                getValues={getValues}
                                watch={watch}
                                errors={errors}
                                clearErrors={clearErrors}
                                setError={setError}
                                phoneNumbers={phoneNumbers}
                                lunaid={lunaInfo.lunaid}
                                setSuccessMessage={setSuccessMessage}
                                allLocations={allLocations}
                                billingGroupList={billingGroupList}
                                setIsloading={setIsloading}
                                assocCallFlows={assocCallFlows}
                              />
                              <div className="routing-border"></div>
                            </section>
                            <section ref={section2} id="locations">
                              <LunaLocation
                                locations={locations}
                                setValue={setValue}
                                control={control}
                                reset={reset}
                                clearErrors={clearErrors}
                                errors={errors}
                              />
                            </section>
                            <div className="routing-border"></div>
                            <section ref={section3} id="schedule" style={{ paddingBottom: "28rem" }}>
                              <LunaLocSchedule
                                register={register}
                                setValue={setValue}
                                getValues={getValues}
                                errors={errors}
                                unregister={unregister}
                                holidaysList={holidaysList}
                                locationid={null}
                                setSuccessMessage={setSuccessMessage}
                                lunaid={lunaInfo.lunaid}
                                allLocations={allLocations}
                                schedules={schedules}
                                watch={watch}
                                reset={reset}
                                setenableHolidays={setenableHolidays}
                                clearErrors={clearErrors}
                                setRerender={setRerender}
                                customSchedule={customSchedule}
                              />
                            </section>
                          </div>
                          {isSave && (
                            <SaveChanges
                              onClose={closeSave}
                              isdirtyFields={isSave}
                              onSave={(e) => {
                                e.preventDefault();
                                handleImportAndSubmit();
                              }}
                            />
                          )}
                        </MDBCol>
                      </MDBRow>
                    </MDBTabsPane>
                    {twentyFourSeven && (
                      <>
                        <MDBTabsPane open={basicActive === "tab2"}>
                          <OpenSchedule
                            isActive={basicActive === "tab2"}
                            scheduleId={1}
                            lunaid={lunaInfo.lunaid}
                            twentyFourSeven={twentyFourSeven}
                            basicActive={basicActive}
                          />
                        </MDBTabsPane>
                      </>
                    )}
                    {!twentyFourSeven && (
                      <>
                        <MDBTabsPane open={basicActive === "tab3"}>
                          <OpenSchedule
                            isActive={basicActive === "tab3"}
                            scheduleId={2}
                            lunaid={lunaInfo.lunaid}
                            twentyFourSeven={twentyFourSeven}
                            basicActive={basicActive}
                          />
                        </MDBTabsPane>

                        <MDBTabsPane open={basicActive === "tab4"}>
                          <OpenSchedule
                            isActive={basicActive === "tab4"}
                            scheduleId={3}
                            lunaid={lunaInfo.lunaid}
                            twentyFourSeven={twentyFourSeven}
                            basicActive={basicActive}
                          />
                        </MDBTabsPane>
                      </>
                    )}
                    {enableHolidays && (
                      <MDBTabsPane open={basicActive === "tab5"}>
                        <OpenSchedule
                          isActive={basicActive === "tab5"}
                          scheduleId={4}
                          lunaid={lunaInfo.lunaid}
                          twentyFourSeven={twentyFourSeven}
                          basicActive={basicActive}
                        />
                      </MDBTabsPane>
                    )}
                  </MDBTabsContent>
                </div>
              </div>
            </section>
            {successMessage && (
              <>
                <TopSuccess>
                  <TopMessage successMessage={successMessage} />
                </TopSuccess>
              </>
            )}
            {isloading && (
              <>
                <div className="loadingclass">
                  <MDBBtn disabled>
                    <MDBSpinner
                      size="sm"
                      role="status"
                      tag="span"
                      className="me-2"
                    />
                    Loading...
                  </MDBBtn>
                </div>
              </>
            )}
            {showExportWarning && (
              <ImportProgressWarning
                warningToggle={exportwarningToggle}
                setShowWarning={setShowExportWarning}
                onOk={exportwarningToggle}
                message={warningMessage}
              />
            )}

            {showImpExpRedirect && (
              <ImpExpRedirectPopup
                onProceed={() => {
                  setShowImpExpRedirect(false);
                  setfirstRequest(true);
                  importuserToggle();
                }}
                onCancel={() => setShowImpExpRedirect(false)}
              />
            )}

            <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
              <MDBModalDialog size="fullscreen">
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Import User Template</MDBModalTitle>
                  </MDBModalHeader>
                  <MDBModalBody className="pb-0">
                    <ImportUser
                      onClose={importuserToggle}
                      setIsloading={() => {}}
                      onShow={setimportUser}
                      show={importUser}
                      firstRequest={firstRequest}
                      setfirstRequest={setfirstRequest}
                    />
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          </>
        }
      />
    </React.Fragment>
  );
}
export default LunaSettings;
